import { Allergen } from "../../../admin/products/productsTypes"
import { DishParameterType } from "../templates/menuTemplatesTypes"

/** The week menu covers the whole week, Monday first. */
export const WEEK_DAY_COUNT = 7

export enum WeekDayPublishStatus {
    DRAFT = "DRAFT",
    PUBLISHED = "PUBLISHED",
    UPDATED = "UPDATED",
}

export enum WeekMenuCellState {
    EMPTY = "EMPTY",
    TEMPLATE_DEFAULT = "TEMPLATE_DEFAULT",
    NEEDS_FILL = "NEEDS_FILL",
    FILLED = "FILLED",
}

// TODO: replace the local object URL with the API picture reference once uploads exist.
/** The week-menu API is not ready, so cell photos live locally (object URL) until save exists. */
export type WeekMenuPhoto = Readonly<{
    url?: string
    name: string
    isFromTemplate: boolean
}>

/** Extra dish info shown in the details dialog, outside the filled and empty cell state. */
export type WeekMenuDishDetails = Readonly<{
    ingredients: string
    nutrition: string
    co2: string
}>

export type WeekMenuCellValues = Readonly<{
    title: string
    description: string
    allergens: ReadonlyArray<Allergen>
    price: string
    marketingTag: string
    photo: WeekMenuPhoto | null
    details: WeekMenuDishDetails
}>

export type WeekMenuCell = Readonly<{
    values: WeekMenuCellValues
    /** The kitchen edited this cell (as opposed to it only carrying template defaults). */
    isTouched: boolean
}>

/** A theme dish edits the same value shape as a regular cell, so the cell UI is reused as is. */
export type ThemeDishValues = WeekMenuCellValues

/** The id survives adding and removing dishes, so React keeps each card's own DOM node. */
export type ThemeDish = Readonly<{
    id: string
    values: ThemeDishValues
}>

/** A theme day (e.g. "Spanish day") replaces the day's template dishes with its own list. */
export type ThemeDay = Readonly<{
    name: string
    dishes: ReadonlyArray<ThemeDish>
}>

export type WeekMenuDayState = Readonly<{
    isPublishEnabled: boolean
    status: WeekDayPublishStatus
    isClosed: boolean
    theme: ThemeDay | null
}>

export type WeekDishField = Readonly<{
    isShown: boolean
    type: DishParameterType
    defaultValue: string
}>

/** One template dish slot rendered as a row of the week table. */
export type WeekDishRow = Readonly<{
    key: string
    name: string
    availableDayIndexes: ReadonlyArray<number>
    description: WeekDishField
    price: WeekDishField
    priceSameAllWeek: boolean
    allergens: WeekDishField
    defaultAllergens: ReadonlyArray<Allergen>
    marketingTag: WeekDishField
    image: WeekDishField
}>

export type WeekCategoryRows = Readonly<{
    name: string
    dishes: ReadonlyArray<WeekDishRow>
}>

/** The cell currently being dragged; its row highlights the eligible drop targets. */
export type WeekMenuDragSource = Readonly<{
    rowKey: string
    dayIndex: number
}>

/** A dish already used somewhere this week, offered as a previous menus suggestion. */
export type RecentDish = Readonly<{
    title: string
    description: string
    price: string
    allergens: ReadonlyArray<Allergen>
}>
